/*
 * 创建新智能体
 */

import React, { useState } from 'react';
import { SVGPureIcon } from '@ui/svg-icon';
import { observer } from 'mobx-react-lite';
import { Input,  Dropdown, Button } from 'antd';
// import store from './store';
import './index.scss';
import { useMemo } from 'react';
import { useCallback } from 'react';
import store from './store';
import dayjs from 'dayjs';
import { HelpOther } from '@/common/helper';
import Checkbox from './checkbox';
import { HelperCore } from '@/common/helper';
import { McpFilesConfig } from '@shared/constants/mcp';

function WcpDownload({
  fileList,
  chatId,
  handleAction,
  onClose = evt => {},
  onSucc = evt => {},
  mcpStore,
}) {
  

  const onSlectFile = (index, checked ) => {
    setData(v => {
      const newData = [...v];
      newData[index].checked = checked;
      return newData;
    });
  };


  async function downloadImage(imageUrl, filename, type) {
    try {
      // 发起 fetch 请求获取图片
      const response = await fetch(imageUrl);

      // 检查响应是否成功
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // 获取图片的 Blob 对象
      const blob = await response.blob();

      // 创建一个指向该 Blob 的 URL
      const blobUrl = URL.createObjectURL(blob);

      // 创建一个隐藏的 <a> 元素用于下载
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = blobUrl;
      a.download = filename || 'downloaded-image.jpg'; // 设置默认文件名

      // 强制设置下载属性（某些浏览器需要）
      a.setAttribute('download', filename || 'downloaded-image.jpg');

      // 将元素添加到文档中并触发点击
      document.body.appendChild(a);
      a.click();

      // 清理
      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      HelpOther.toast('下载失败', 'error');
    }
  }

  const createDownload = async (url, fileName = 'download') => {
    
    if (/^https/.test(url)) {
      let _fileName = fileName;
      if (!/(\.[a-z]{1,4})(?:$|\?)/gi.test(_fileName) && /(\.[a-z]{1,4})(?:$|\?)/gi.test(url)) {
        _fileName = fileName + RegExp.$1;
      }
      if (/qinui/.test(url)) {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;
        if (!params.get('attname')) {
          params.set('attname', encodeURIComponent(_fileName))
        }
        HelperCore.saveFile(urlObj.href, _fileName)
      } 
      else if (/xstore/.test(url)) {
        const urlObj = new URL(url);
        const params = urlObj.searchParams;
        if (!params.get('response-content-disposition')) {
          params.set('response-content-disposition', 'attname');
          params.set('filename', encodeURIComponent(_fileName))
        }
        HelperCore.saveFile(urlObj.href, _fileName)
      }
      else {
        const blob = await fetch(url).then(res => res.blob()).catch(err => null);
        if (blob) {
          const url = URL.createObjectURL(blob);
          HelperCore.saveFile(url, _fileName);
        }
      }
    }
    
  };

  const [data, setData] = useState(fileList);
  const [changeDownload, setChangeDownload] = useState(false);

  const checkedList = useMemo(() => {
    return data.filter(item => item.checked);
  }, [data]);
  const checkAll = useMemo(() => {
    return data.length === checkedList.length;
  }, [data, checkedList]);
  const indeterminate = useMemo(() => {
    return checkedList.length > 0 && checkedList.length < data.length;
  }, [checkedList, data]);

  const onSelectAll = (checked) => {
    setData((v) => {
      return v.map((item) => {
        return {
          ...item,
          checked: checked
        }

      })
    }) 
  }

  const batchDownload = useCallback(() => {
    store.agentBatchDownload(
      {
        cid: chatId,
        files: checkedList
          .map(item => ({
            url: item.url,
            name: item.title,
          }))
          .filter(item => !!item.url),
      },
      download_url => {
        createDownload(download_url);
      }
    );
  }, [checkedList]);

  const renderDiffTime = timestamp => {
    if (!timestamp) return null;
    timestamp *= 1000;
    const now = Date.now();
    const minutesAgo = dayjs(now).diff(timestamp, 'minute');

    if (minutesAgo < 1) return '刚刚发送';
    if (minutesAgo < 60) return `${minutesAgo}分钟前`;

    const hoursAgo = Math.floor(minutesAgo / 60);
    if (hoursAgo < 24) return `${hoursAgo}小时前`;

    return dayjs(timestamp).format('YYYY-MM-DD HH:mm');
  };
  return (
    <div className="w-648px pt-30px pb-20px  bg-[#fff] rounded-24px relative">
      <div className="text-24px font-medium leading-34px text-[#000] mb-16px px-24px">
        此任务中的所有文件
      </div>
      {!changeDownload ? (
        <div
          onClick={() => setChangeDownload(true)}
          className="absolute cursor-pointer top-18px right-60px w-28px flex items-center justify-center h-28px hover:bg-[rgba(0,0,0,0.06)] hover:rounded-8px"
        >
          <SVGPureIcon
            style={{
              opacity: '0.5',
            }}
            iconClass="text-opacity-50"
            size={28}
            name="ic-download"
          />
        </div>
      ) : null}

      <div className="h-536px overflow-y-auto pb-85px nw-scrollbar-x-thin px-24px">
        {data.map((item, index) => {
          const config = McpFilesConfig[item.contentType] || McpFilesConfig.default;

          return (
            <div
              key={index}
              className={`flex items-center py-15px ${config.supportPreview ? 'cursor-pointer' : ''}`}
              data-id={item.planStepId}
              onClick={
                () => {
                  if(config.supportPreview){
                    handleAction('view', item);
                    onClose();
                  }
                }
              }
            >
              {changeDownload ? (
                <div className="mr-12px">
                  <Checkbox
                    onPassChencked={checked => onSlectFile(index, checked)}
                    passChecked={item.checked}
                  />
                </div>
              ) : null}
              <div
                style={{
                  backgroundImage: `url(${config.icon})`,
                }}
                className="w-40px h-40px bg-cover mr-16px rounded-100px"
              ></div>
              <div className="flex-1">
                <div className="text-16px text-[#000] font-semibold mb-2px leading-22px">
                  {item.title}
                </div>
                <div className="text-12px text-[rgba(0,0,0,.5)] font-normal leading-17px">
                  {renderDiffTime(item?.timestamp)}
                </div>
              </div>
              <Dropdown
                overlayClassName="custom-overlay-dropdown"
                className="custom-dropdown"
                overlay={
                  <div
                    style={{
                      boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.10)',
                    }}
                    className="p-8px w-150px border-[rgba(0,0,0,0.06)] rounded-16px"
                    onClick={
                      event => {
                        event.stopPropagation();
                      }
                    }
                  >
                    <ul className="m-0 p-0" style={{ listStyleType: 'none' }}>
                      {
                        config.supportPreview
                        ? (
                          <li
                            onClick={() => {
                              handleAction('view', item);
                              onClose();
                            }}
                            className="h-40px box-border px-8px py-13px flex cursor-pointer items-center text-14px leading-22px font-normal hover:bg-[rgba(0,0,0,0.06)] hover:rounded-8px"
                          >
                            <SVGPureIcon size={20} name="preview" />
                            <span className="ml-8px">预览</span>
                          </li>
                        )
                        : null
                      }
                      {
                        mcpStore.toolsNodes.some(_ => _.planStepId == item.planStepId)
                        ? (
                          <li
                            onClick={() => {
                              onClose();
                              handleAction('position', item);
                            }}
                            className="h-40px box-border px-8px py-13px flex cursor-pointer items-center text-14px leading-22px font-normal hover:bg-[rgba(0,0,0,0.06)] hover:rounded-8px"
                          >
                            <SVGPureIcon
                              className="flex-shrink-0"
                              size={20}
                              name="location"
                            />
                            <span
                              className="ml-8px"
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              在对话中定位
                            </span>
                          </li>
                        ) 
                        : null
                      }
                      {item.url ? (
                        <li
                          onClick={() => {
                            if (item.contentType == 'image') {
                              createDownload(item.url, item.title);
                              return;
                            }
                            createDownload(item.url, item.title);
                          }}
                          className="h-40px box-border px-8px py-13px flex cursor-pointer items-center text-14px leading-22px font-normal hover:bg-[rgba(0,0,0,0.06)] hover:rounded-8px"
                        >
                          <SVGPureIcon size={20} name="download" />
                          <span className="ml-8px">下载文件</span>
                        </li>
                      ) : null}
                    </ul>
                  </div>
                }
                // open={true}
                placement="bottomRight"
                dropdownRender={overlay => (
                  <div
                    className="bg-[#fff] rounded-16px"
                    style={{ padding: '4px 0' }}
                  >
                    {overlay}
                  </div>
                )}
              >
                <div 
                  className="flex cursor-pointer items-center justify-center w-24px h-24px rounded-8px hover:bg-[rgba(0,0,0,0.03)]"
                  onClick={
                    event => {
                      event.stopPropagation();
                    }
                  }
                  >
                  <SVGPureIcon
                    className="text-[#000]"
                    name="more_1"
                    size={24}
                  />
                </div>
              </Dropdown>
            </div>
          );
        })}
      </div>
      {changeDownload ? (
        <div className=" absolute bottom-0 left-0 w-full pb-24px px-24px bg-[#fff] ">
          <div className=" border-t-1px pt-20px flex items-center">
            <div className="leading-20px flex-1 inline-flex items-center">
              <Checkbox
                passChecked={checkAll}
                indeterminate={indeterminate}
                // onClickAll={onSelectAll}
                onPassChencked={checked => onSelectAll( checked)}
              />
              <span className="text-14px font-normal text-[#000] ">
                全选
              </span>
            </div>
            <Button
              onClick={() => setChangeDownload(false)}
              className="download-cancel !min-w-104px !h-40px !cursor-pointer  !rounded-12px !text-center !text-16px !text-[#000] !font-medium !bg-[rgba(0,0,0,0.06)]"
            >
              取消
            </Button>
            <Button
              loading={store.loading}
              onClick={() => batchDownload()}
              className="batch-download !min-w-104px !h-40px !cursor-pointer  !rounded-12px !text-center !text-16px !text-[#fff] !font-medium !bg-[#000] !ml-12px !hover:bg-[#333]"
            >
              批量下载
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default observer(WcpDownload);
